import { useState, useEffect } from "react";
import { request } from "graphql-request";
import { baseUrl } from "services/shared/Environment";
import { categoryStoriesQuery } from "./HomepageStories.utils";
import { ApiStory, parseApiStory } from "data/api/ApiStory";
import { usePageProps } from "../Homepage.hooks";

export function useCategories() {
  const { categories } = usePageProps()
  return { categories: categories ?? [] };
}

export function useCategoryStories({
  categoryId,
  numStoriesLoaded
}: {
  categoryId: string;
  numStoriesLoaded: number;
}) {

  const { categoryStories } = usePageProps()
  const initialStories = categoryStories[categoryId]

  const [stories, setStories] = useState<ApiStory[]>(initialStories ?? []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await request(
          `${baseUrl()}/api/graphql`,
          categoryStoriesQuery({ categoryId, numStoriesLoaded })
        );
        setStories(
          response?.categoryStories?.map((story) => parseApiStory(story))
        );
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    if(numStoriesLoaded > 4) {
      fetchData();
    }
  }, [numStoriesLoaded, categoryId]);

  return { stories, loading };
}
